const NextMention = (props) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.5388 6.12592C12.2242 6.507 12.2242 7.49285 11.5388 7.87393L1.50633 13.4516C0.839789 13.8222 0.0204089 13.3403 0.0204089 12.5776L0.0204095 1.4222C0.0204095 0.65958 0.839791 0.177627 1.50633 0.548199L11.5388 6.12592Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9108 0.923828C12.3585 0.923828 11.9108 1.32171 11.9108 1.81253L11.9108 12.0351C11.9108 12.5259 12.3585 12.9238 12.9108 12.9238C13.4631 12.9238 13.9108 12.5259 13.9108 12.0351L13.9108 1.81253C13.9108 1.32171 13.4631 0.923828 12.9108 0.923828Z"
      fill="currentColor"
    />
  </svg>
);
export default NextMention;
